/* ─────────────────────────────────────────────────────────────
   gpc-nextday-showcase.js
   Upload to: Assets/   (paired with sections/gpc-nextday-showcase.liquid)

   The Buy now button on the homepage Next Day cards.

   This is the same add-to-cart behaviour as the Next Day landing page,
   which keeps it inline at sections/next-day-lp.liquid:139. That works
   there because the LP is a collection template. On the home page an
   inline <script> in a section is never executed — it lands in the DOM
   untouched — so this has to be an asset loaded globally instead.

   Loaded GLOBALLY from snippets/head.liquid, NOT from the section:
     <script src="{{ 'gpc-nextday-showcase.js' | asset_url }}" defer></script>

   Delegated from document, so it does not care when the section arrives
   or how many of them there are. Nothing to initialise.

   Do not move this back inline.
   ───────────────────────────────────────────────────────────── */

(function () {
  var CART_SVG =
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ' +
    'style="vertical-align:-2px;margin-right:6px;">' +
    '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
    '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gpcn-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    var productUrl = btn.getAttribute('data-product-url');
    var label = btn.querySelector('[data-gpcn-label]');
    var original = label ? label.textContent : '';

    // No variant id means the product data never made it into the markup.
    // Sending them to the product page is better than a button that fails.
    if (!variantId) {
      if (productUrl) window.location.href = productUrl;
      return;
    }

    btn.disabled = true;
    if (label) label.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        if (label) label.innerHTML = CART_SVG + 'Added to Cart';
        window.location.href = '/cart';
      })
      .catch(function () {
        // Most likely it sold out between the page rendering and the click.
        // The product page will say so properly, rather than us guessing.
        if (productUrl) {
          window.location.href = productUrl;
        } else {
          if (label) label.textContent = original;
          btn.disabled = false;
        }
      });
  });

  // Confirm which build the store is serving: type  window.GPCN_VERSION  in
  // the console. Undefined means this asset is not loaded at all — check the
  // <script> line in snippets/head.liquid.
  window.GPCN_VERSION = '2026-08-13 buy-now';
})();
